import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Dark Theme (Default) */
    --background-dark: #0a192f;
    --secondary-dark: #112240;
    --text-primary-dark: #ccd6f6;
    --text-secondary-dark: #8892b0;
    --accent-dark: #64ffda;
    
    /* Light Theme */
    --background-light: #f5f5f5;
    --secondary-light: #e0e0e0;
    --text-primary-light: #333333;
    --text-secondary-light: #666666;
    --accent-light: #007bff;
    
    /* Active Theme (Initially Dark) */
    --background: var(--background-dark);
    --secondary: var(--secondary-dark);
    --text-primary: var(--text-primary-dark);
    --text-secondary: var(--text-secondary-dark);
    --accent: var(--accent-dark);
    
    /* Other Variables */
    --nav-height: 100px;
    --border-radius: 4px;
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;
  }

  body.light-theme {
    --background: var(--background-light);
    --secondary: var(--secondary-light);
    --text-primary: var(--text-primary-light);
    --text-secondary: var(--text-secondary-light);
    --accent: var(--accent-light);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: var(--background);
    color: var(--text-primary);
    font-family: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui, sans-serif;
    line-height: 1.3;
    font-size: var(--fz-xl);

    &::-webkit-scrollbar {
      width: 12px;
    }
    
    &::-webkit-scrollbar-track {
      background: var(--secondary);
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: var(--text-secondary);
      border: 3px solid var(--secondary);
      border-radius: 10px;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0 0 10px 0;
    font-weight: 600;
    color: var(--text-primary);
    line-height: 1.1;
  }

  p {
    line-height: 1.5;
    margin: 0 0 15px 0;
  }

  a {
    text-decoration: none;
    color: var(--accent);
    transition: var(--transition);

    &:hover,
    &:focus {
      color: var(--accent);
    }
  }

  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    vertical-align: middle;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  .section-heading {
    display: flex;
    align-items: center;
    position: relative;
    margin: 10px 0 40px;
    width: 100%;
    font-size: clamp(26px, 5vw, var(--fz-heading));
    white-space: nowrap;

    &:after {
      content: '';
      display: block;
      position: relative;
      width: 300px;
      height: 1px;
      margin-left: 20px;
      background-color: var(--text-secondary);

      @media (max-width: 768px) {
        width: 200px;
      }

      @media (max-width: 480px) {
        width: 100px;
      }
    }
  }

  // Animations
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fadeIn {
    animation: fadeIn 0.5s ease forwards;
  }
`;

export default GlobalStyles;